(function () {
  'use strict';

  /** Read config from Shopify section data attributes (no inline Liquid in script tags). */
  function bootstrapShopifyConfig() {
    if (typeof window === 'undefined' || typeof document === 'undefined') return;
    var root = document.querySelector('[data-custom-design-request]');
    if (!root || !root.dataset) return;
    var d = root.dataset;
    if (d.submitApi) window.CUSTOM_SUBMIT_API = d.submitApi;
    if (d.submitToken) window.CUSTOM_SUBMIT_TOKEN = d.submitToken;
    if (d.shopDomain) window.CUSTOM_SHOP_DOMAIN = d.shopDomain;
    if (d.customerId) window.CUSTOM_CUSTOMER_ID = d.customerId;
    if (d.customerEmail) window.CUSTOM_CUSTOMER_EMAIL = d.customerEmail;
  }
  bootstrapShopifyConfig();

  var MAX_FILES = 10;
  var ASPECT_MATCH_TOLERANCE = 0.1;

  /** Flattened unique sizes + lookup; filled by initSizeCatalogue(). */
  var STANDARD_SIZES = [];
  var SIZE_BY_ID = {};
  var ASPECT_RATIO_KEYS = [];
  var NOMINAL_AR_FOR_KEY = {};

  var SIZE_CATALOGUE = {
    _meta: {
      description: 'Aspect ratio → canvas sizes for exact-size mode. Edit here only.',
      unit: 'cm'
    },
    '1:1': [
      { id: '30x30', label: '30 x 30 cm', width: 30, height: 30, band: 'small' },
      { id: '40x40', label: '40 x 40 cm', width: 40, height: 40, band: 'medium' },
      { id: '50x50', label: '50 x 50 cm', width: 50, height: 50, band: 'large' },
      { id: '60x60', label: '60 x 60 cm', width: 60, height: 60, band: 'extra_large' },
      { id: '80x80', label: '80 x 80 cm', width: 80, height: 80, band: 'epic' },
      { id: '100x100', label: '100 x 100 cm', width: 100, height: 100, band: 'gigantic' }
    ],
    '4:3': [
      { id: '40x30', label: '40 x 30 cm', width: 40, height: 30, band: 'small' },
      { id: '50x40', label: '50 x 40 cm', width: 50, height: 40, band: 'medium' },
      { id: '60x50', label: '60 x 50 cm', width: 60, height: 50, band: 'large' },
      { id: '80x60', label: '80 x 60 cm', width: 80, height: 60, band: 'extra_large' },
      { id: '100x80', label: '100 x 80 cm', width: 100, height: 80, band: 'epic' }
    ],
    '3:4': [
      { id: '30x40', label: '30 x 40 cm', width: 30, height: 40, band: 'small' },
      { id: '40x50', label: '40 x 50 cm', width: 40, height: 50, band: 'medium' },
      { id: '50x60', label: '50 x 60 cm', width: 50, height: 60, band: 'large' },
      { id: '60x80', label: '60 x 80 cm', width: 60, height: 80, band: 'extra_large' },
      { id: '80x100', label: '80 x 100 cm', width: 80, height: 100, band: 'epic' }
    ],
    '5:4': [
      { id: '40x30', label: '40 x 30 cm', width: 40, height: 30, band: 'small' },
      { id: '50x40', label: '50 x 40 cm', width: 50, height: 40, band: 'medium' },
      { id: '60x50', label: '60 x 50 cm', width: 60, height: 50, band: 'large' },
      { id: '80x60', label: '80 x 60 cm', width: 80, height: 60, band: 'extra_large' },
      { id: '100x80', label: '100 x 80 cm', width: 100, height: 80, band: 'epic' }
    ],
    '4:5': [
      { id: '30x40', label: '30 x 40 cm', width: 30, height: 40, band: 'small' },
      { id: '40x50', label: '40 x 50 cm', width: 40, height: 50, band: 'medium' },
      { id: '50x60', label: '50 x 60 cm', width: 50, height: 60, band: 'large' },
      { id: '60x80', label: '60 x 80 cm', width: 60, height: 80, band: 'extra_large' },
      { id: '80x100', label: '80 x 100 cm', width: 80, height: 100, band: 'epic' }
    ],
    '7:5': [
      { id: '40x30', label: '40 x 30 cm', width: 40, height: 30, band: 'small' },
      { id: '50x40', label: '50 x 40 cm', width: 50, height: 40, band: 'medium' },
      { id: '60x40', label: '60 x 40 cm', width: 60, height: 40, band: 'large' },
      { id: '70x50', label: '70 x 50 cm', width: 70, height: 50, band: 'extra_large' },
      { id: '100x70', label: '100 x 70 cm', width: 100, height: 70, band: 'epic' }
    ],
    '5:7': [
      { id: '30x40', label: '30 x 40 cm', width: 30, height: 40, band: 'small' },
      { id: '40x50', label: '40 x 50 cm', width: 40, height: 50, band: 'medium' },
      { id: '40x60', label: '40 x 60 cm', width: 40, height: 60, band: 'large' },
      { id: '50x70', label: '50 x 70 cm', width: 50, height: 70, band: 'extra_large' },
      { id: '70x100', label: '70 x 100 cm', width: 70, height: 100, band: 'epic' }
    ],
    '3:2': [
      { id: '40x30', label: '40 x 30 cm', width: 40, height: 30, band: 'small' },
      { id: '50x30', label: '50 x 30 cm', width: 50, height: 30, band: 'medium' },
      { id: '60x40', label: '60 x 40 cm', width: 60, height: 40, band: 'large' },
      { id: '90x60', label: '90 x 60 cm', width: 90, height: 60, band: 'extra_large' },
      { id: '100x70', label: '100 x 70 cm', width: 100, height: 70, band: 'epic' }
    ],
    '2:3': [
      { id: '30x40', label: '30 x 40 cm', width: 30, height: 40, band: 'small' },
      { id: '30x50', label: '30 x 50 cm', width: 30, height: 50, band: 'medium' },
      { id: '40x60', label: '40 x 60 cm', width: 40, height: 60, band: 'large' },
      { id: '60x90', label: '60 x 90 cm', width: 60, height: 90, band: 'extra_large' },
      { id: '70x100', label: '70 x 100 cm', width: 70, height: 100, band: 'epic' }
    ],
    '2:1': [
      { id: '50x30', label: '50 x 30 cm', width: 50, height: 30, band: 'medium' },
      { id: '60x30', label: '60 x 30 cm', width: 60, height: 30, band: 'large' },
      { id: '80x40', label: '80 x 40 cm', width: 80, height: 40, band: 'extra_large' },
      { id: '100x50', label: '100 x 50 cm', width: 100, height: 50, band: 'epic' }
    ],
    '1:2': [
      { id: '30x50', label: '30 x 50 cm', width: 30, height: 50, band: 'medium' },
      { id: '30x60', label: '30 x 60 cm', width: 30, height: 60, band: 'large' },
      { id: '40x80', label: '40 x 80 cm', width: 40, height: 80, band: 'extra_large' },
      { id: '50x100', label: '50 x 100 cm', width: 50, height: 100, band: 'epic' }
    ]
  };

  var RANGE_BANDS = [
    { value: 'small', label: 'Small' },
    { value: 'medium', label: 'Medium' },
    { value: 'large', label: 'Large' },
    { value: 'extra_large', label: 'Extra Large' },
    { value: 'epic', label: 'Epic' }
  ];

  var RANGE_LONGEST_EDGE_CM = {
    small: { min: 30, max: 40 },
    medium: { min: 50, max: 60 },
    large: { min: 70, max: 90 },
    extra_large: { min: 100, max: 120 },
    epic: { min: 130, max: 150 }
  };

  var CLARITY_OPTS = [
    { value: '35', label: 'Good (35)' },
    { value: '50', label: 'Better (50)' },
    { value: '65', label: 'Best (65)' }
  ];

  var DRILL_OPTS = [
    { value: 'round', label: 'Round' },
    { value: 'square', label: 'Square' }
  ];

  var SIZE_MODE_OPTS = [
    { value: 'exact', label: 'I will select size', title: 'I will select the canvas size myself' },
    { value: 'range', label: 'Select a size for me', title: 'Choose a size range and we will select the best canvas fit' }
  ];

  var CURRENCY = new Intl.NumberFormat('en-AU', { style: 'currency', currency: 'AUD' });
  var CANVAS_COST_PER_SQM = 8.5;
  var DRILL_COST = 1.75;
  var DRILL_OVERAGE = 1.2;
  var PACKAGING_FEE = 10;
  var TARGET_MARGIN_PERCENT = 92;
  var PRICE_AFTER_AREA_MULT = 1.1;

  var SUBMIT_API_PATH = '/api/v1/custom-design-request';
  var DEFAULT_SUBMIT_API =
    'https://diamond-painting-proofs-7005919314.development.catalystserverless.com.au/server/custom_design_submit/api/v1/custom-design-request';

  /** Catalyst console “function URL” omits /api/v1/... — fix before fetch. */
  function normalizeSubmitApiUrl(url) {
    url = String(url || '').trim();
    if (!url) return DEFAULT_SUBMIT_API;
    if (url.indexOf(SUBMIT_API_PATH) !== -1) {
      return url.replace(/\/+$/, '');
    }
    if (url.indexOf('custom_design_submit') !== -1) {
      return url.replace(/\/+$/, '') + SUBMIT_API_PATH;
    }
    return url;
  }

  /** Resolved at submit time from window or section data attributes. See API-CONTRACT.md */
  function getSubmitApiUrl() {
    var url = '';
    if (typeof window !== 'undefined' && window.CUSTOM_SUBMIT_API) {
      url = String(window.CUSTOM_SUBMIT_API).trim();
    } else {
      var root = typeof document !== 'undefined' && document.querySelector('[data-custom-design-request]');
      if (root && root.dataset && root.dataset.submitApi) {
        url = String(root.dataset.submitApi).trim();
      }
    }
    return normalizeSubmitApiUrl(url);
  }

  var state = { step: 0, items: [], submitting: false };
  var els = {};

  function initSizeCatalogue() {
    ASPECT_RATIO_KEYS = Object.keys(SIZE_CATALOGUE).filter(function (k) { return k !== '_meta'; });
    NOMINAL_AR_FOR_KEY = {};
    ASPECT_RATIO_KEYS.forEach(function (k) {
      var p = k.split(':');
      var a = parseInt(p[0], 10);
      var b = parseInt(p[1], 10);
      if (a && b) NOMINAL_AR_FOR_KEY[k] = a / b;
    });
    SIZE_BY_ID = {};
    STANDARD_SIZES = [];
    ASPECT_RATIO_KEYS.forEach(function (k) {
      var arr = SIZE_CATALOGUE[k];
      if (!Array.isArray(arr)) return;
      arr.forEach(function (s) {
        if (!s || !s.id) return;
        if (!SIZE_BY_ID[s.id]) {
          SIZE_BY_ID[s.id] = s;
          STANDARD_SIZES.push(s);
        }
      });
    });
    STANDARD_SIZES.sort(function (a, b) {
      var aa = a.width * a.height;
      var bb = b.width * b.height;
      if (aa !== bb) return aa - bb;
      return String(a.id).localeCompare(String(b.id));
    });
  }

  function classifyAspectKey(imgAr) {
    if (imgAr == null || !isFinite(imgAr) || imgAr <= 0) return null;
    var best = null;
    var bestDist = Infinity;
    ASPECT_RATIO_KEYS.forEach(function (k) {
      var nom = NOMINAL_AR_FOR_KEY[k];
      if (nom == null) return;
      if (!aspectRatiosMatch(imgAr, nom)) return;
      var d = Math.abs(imgAr - nom);
      if (d < bestDist) {
        bestDist = d;
        best = k;
      }
    });
    return best;
  }

  function rangeBandLabel(value) {
    var b = RANGE_BANDS.find(function (x) { return x.value === value; });
    return b ? b.label : (value || '—');
  }

  function rangeSelectionHint(bandId) {
    if (!bandId || !RANGE_LONGEST_EDGE_CM[bandId]) return '';
    var edge = RANGE_LONGEST_EDGE_CM[bandId];
    return 'Longest side will be ' + edge.min + '–' + edge.max + ' cm depending on image aspect ratio';
  }

  function formatMoney(n) {
    return CURRENCY.format(n);
  }

  function clarityAddonAUD(clarity) {
    if (clarity === '50') return 10;
    if (clarity === '65') return 20;
    return 0;
  }

  function areaCostPerSqM() {
    return CANVAS_COST_PER_SQM + DRILL_COST * DRILL_OVERAGE;
  }

  function basePriceFromAreaSqM(areaSqM) {
    var marginFactor = 1 - TARGET_MARGIN_PERCENT / 100;
    if (marginFactor <= 0) marginFactor = 0.01;
    return (areaSqM * areaCostPerSqM()) / marginFactor * PRICE_AFTER_AREA_MULT + PACKAGING_FEE;
  }

  function linePriceAfterClarity(basePrice, clarity) {
    return Math.round(basePrice + clarityAddonAUD(clarity));
  }

  function areaSqMFromCm(w, h) {
    return (w * h) / 10000;
  }

  function exactSizeDimensionsCm(exactId) {
    var o = SIZE_BY_ID[exactId];
    if (o && o.width && o.height) return { w: o.width, h: o.height };
    if (!exactId || String(exactId).indexOf('x') < 0) return null;
    var p = String(exactId).split('x');
    var w = parseInt(p[0], 10);
    var h = parseInt(p[1], 10);
    if (!w || !h) return null;
    return { w: w, h: h };
  }

  function aspectRatiosMatch(imgAr, canvasAr) {
    if (imgAr == null || canvasAr == null || !isFinite(imgAr) || !isFinite(canvasAr) || imgAr <= 0 || canvasAr <= 0) return true;
    var hi = Math.max(imgAr, canvasAr);
    var lo = Math.min(imgAr, canvasAr);
    return (hi - lo) / hi <= ASPECT_MATCH_TOLERANCE;
  }

  function gcdInt(a, b) {
    a = Math.abs(Math.round(a));
    b = Math.abs(Math.round(b));
    while (b) {
      var t = b;
      b = a % b;
      a = t;
    }
    return a || 1;
  }

  function approximateAspectRatioLabel(ar) {
    if (ar == null || !isFinite(ar) || ar <= 0) return null;
    var bestN = 1;
    var bestD = 1;
    var bestErr = Infinity;
    for (var d = 1; d <= 32; d++) {
      var n = Math.round(ar * d);
      if (n < 1) continue;
      var err = Math.abs(n / d - ar) / ar;
      if (err < bestErr) {
        bestErr = err;
        bestN = n;
        bestD = d;
      }
    }
    var g = gcdInt(bestN, bestD);
    return Math.round(bestN / g) + ':' + Math.round(bestD / g);
  }

  function imageAspectRatioDisplayLabel(wPx, hPx) {
    if (wPx == null || hPx == null || !wPx || !hPx) return null;
    var wi = Math.round(wPx);
    var hi = Math.round(hPx);
    var g = gcdInt(wi, hi);
    var rw = Math.round(wi / g);
    var rh = Math.round(hi / g);
    if (rw <= 64 && rh <= 64) return rw + ':' + rh;
    return approximateAspectRatioLabel(wi / hi);
  }

  function exactSizeChoicesForItem(item) {
    if (item.imageMetaError || !STANDARD_SIZES.length) return STANDARD_SIZES.slice();
    var ar = item.imageAspectRatio;
    if (ar == null || !isFinite(ar) || ar <= 0) return STANDARD_SIZES.slice();
    var key = classifyAspectKey(ar);
    if (key && SIZE_CATALOGUE[key] && SIZE_CATALOGUE[key].length) {
      return SIZE_CATALOGUE[key].slice();
    }
    return STANDARD_SIZES.slice();
  }

  function filterExactSizesForItem(item) {
    return exactSizeChoicesForItem(item);
  }

  function idSetFromSizes(list) {
    var o = {};
    list.forEach(function (s) { o[s.id] = true; });
    return o;
  }

  function exactSizesForBulkApply() {
    if (!STANDARD_SIZES.length) return [];
    if (!state.items.length) return STANDARD_SIZES.slice();
    var lists = state.items.map(function (it) { return filterExactSizesForItem(it); });
    var acc = lists[0];
    for (var i = 1; i < lists.length; i++) {
      var keep = idSetFromSizes(lists[i]);
      acc = acc.filter(function (s) { return keep[s.id]; });
    }
    return acc.length ? acc : STANDARD_SIZES.slice();
  }

  function sizesToChoices(sizes) {
    return sizes.map(function (s) {
      return { value: s.id, label: s.label };
    });
  }

  function pruneInvalidExactSizeSelections() {
    state.items.forEach(function (it) {
      if (it.settings.sizeMode !== 'exact' || !it.settings.exactSize) return;
      var ok = idSetFromSizes(exactSizeChoicesForItem(it));
      if (!ok[it.settings.exactSize]) it.settings.exactSize = null;
    });
  }

  function rebuildBulkExactButtons() {
    if (!els.bulkExact) return;
    pruneInvalidExactSizeSelections();
    var list = exactSizesForBulkApply();
    var allowed = idSetFromSizes(list);
    var sel = getGroupValue(els.bulkExact);
    if (sel && !allowed[sel]) sel = null;
    buildExclusiveButtons(els.bulkExact, sizesToChoices(list), sel);
  }

  function scheduleImageAspectDetection(item, objectUrl) {
    var img = new Image();
    img.onload = function () {
      item.imageWidthPx = img.naturalWidth;
      item.imageHeightPx = img.naturalHeight;
      item.imageAspectRatio = img.naturalWidth / img.naturalHeight;
      item.imageMetaError = false;
      rebuildBulkExactButtons();
      renderPerFileCards();
    };
    img.onerror = function () {
      item.imageWidthPx = null;
      item.imageHeightPx = null;
      item.imageAspectRatio = null;
      item.imageMetaError = true;
      rebuildBulkExactButtons();
      renderPerFileCards();
    };
    img.src = objectUrl;
  }

  function priceRangeForBand(bandId, clarity) {
    var band = RANGE_LONGEST_EDGE_CM[bandId];
    if (!band) return null;
    var lo = linePriceAfterClarity(basePriceFromAreaSqM(areaSqMFromCm(band.min, band.min)), clarity);
    var hi = linePriceAfterClarity(basePriceFromAreaSqM(areaSqMFromCm(band.max, band.max)), clarity);
    return { min: Math.min(lo, hi), max: Math.max(lo, hi) };
  }

  function itemPricingInputsComplete(s) {
    if (!s || !s.sizeMode || !s.clarity) return false;
    if (s.sizeMode === 'exact' && !s.exactSize) return false;
    if (s.sizeMode === 'range' && !s.rangeSize) return false;
    return true;
  }

  function calculateLinePricing(settings) {
    if (!itemPricingInputsComplete(settings)) return null;
    if (settings.sizeMode === 'range') {
      var span = priceRangeForBand(settings.rangeSize, settings.clarity);
      if (!span) return null;
      return { kind: 'range', min: span.min, max: span.max };
    }
    var dims = exactSizeDimensionsCm(settings.exactSize);
    if (!dims) return null;
    var amount = linePriceAfterClarity(basePriceFromAreaSqM(areaSqMFromCm(dims.w, dims.h)), settings.clarity);
    return { kind: 'exact', amount: amount };
  }

  function formatLinePriceDisplay(p) {
    if (p == null) return '—';
    if (p.kind === 'exact') return formatMoney(p.amount);
    if (p.kind === 'range') return formatMoney(p.min) + ' – ' + formatMoney(p.max);
    return '—';
  }

  function aggregateLineSubtotal(items) {
    var min = 0;
    var max = 0;
    var ok = true;
    items.forEach(function (it) {
      var p = it.linePrice;
      if (!p) {
        ok = false;
        return;
      }
      if (p.kind === 'exact') {
        min += p.amount;
        max += p.amount;
      } else {
        min += p.min;
        max += p.max;
      }
    });
    return { ok: ok, min: Math.round(min), max: Math.round(max) };
  }

  function formatSubtotalDisplay(agg) {
    if (!agg.ok) return '—';
    if (agg.min === agg.max) return formatMoney(agg.min);
    return formatMoney(agg.min) + ' – ' + formatMoney(agg.max);
  }

  function emptySettings() {
    return { sizeMode: null, exactSize: null, rangeSize: null, clarity: null, drill: null };
  }

  function itemSettingsComplete(s) {
    return itemPricingInputsComplete(s) && !!s.drill;
  }

  function countCompletedItems() {
    return state.items.filter(function (it) {
      return itemSettingsComplete(it.settings);
    }).length;
  }

  function syncFileCardCompleteState(det, settings) {
    if (!det) return;
    det.classList.toggle('file-card--complete', itemSettingsComplete(settings));
  }

  function syncAllFileCardCompleteStates() {
    if (!els.perFileList) return;
    els.perFileList.querySelectorAll('details.file-card').forEach(function (det) {
      var id = det.dataset.itemId;
      var item = state.items.find(function (it) { return it.id === id; });
      if (item) syncFileCardCompleteState(det, item.settings);
    });
  }

  function refreshConfigureEls() {
    els.bulkSettingsPanel = document.getElementById('cs-bulk-settings');
    els.individualImagesPanel = document.getElementById('cs-individual-images');
    els.configureProgress = document.getElementById('cs-configure-progress');
    els.perFileList = document.getElementById('cs-per-file-list');
  }

  var configureScrollSuppressUntil = 0;

  function suppressConfigureScroll(ms) {
    configureScrollSuppressUntil = Date.now() + (ms || 350);
  }

  function isConfigureScrollSuppressed() {
    return Date.now() < configureScrollSuppressUntil;
  }

  function syncConfigurePanelUI() {
    refreshConfigureEls();
    var single = state.items.length <= 1;
    if (els.bulkSettingsPanel) {
      els.bulkSettingsPanel.classList.toggle('bulk-settings--hidden', single);
    }
  }

  function openConfigureForSingleImage() {
    if (state.items.length !== 1) return;
    refreshConfigureEls();
    ensureConfigureCardsRendered();
    if (els.individualImagesPanel && !els.individualImagesPanel.open) {
      els.individualImagesPanel.open = true;
    }
    var card = els.perFileList && els.perFileList.querySelector('details.file-card');
    if (!card) {
      renderPerFileCards();
      card = els.perFileList && els.perFileList.querySelector('details.file-card');
    }
    if (card && !card.open) {
      card.open = true;
    }
  }

  function updateConfigureProgress() {
    var total = state.items.length;
    var done = countCompletedItems();
    if (els.configureProgress) {
      els.configureProgress.textContent = done + ' out of ' + total + ' completed';
    }
    if (els.individualImagesPanel) {
      els.individualImagesPanel.classList.toggle('card--all-complete', total > 0 && done === total);
    }
    syncConfigurePanelUI();
    syncAllFileCardCompleteStates();
  }

  function ensureConfigureCardsRendered() {
    if (state.items.length && els.perFileList && !els.perFileList.querySelector('.file-card')) {
      renderPerFileCards();
    }
  }

  function closeBulkSettingsPanel() {
    if (!els.bulkSettingsPanel || !els.bulkSettingsPanel.open) return;
    els.bulkSettingsPanel.open = false;
    scrollToConfigureAnchor();
  }

  function uid() {
    if (typeof crypto !== 'undefined' && crypto.randomUUID) return crypto.randomUUID();
    return 'id-' + Date.now() + '-' + Math.random().toString(36).slice(2);
  }

  function clarityLabel(v) {
    if (v == null || v === '') return '—';
    if (v === '35') return 'Good (35)';
    if (v === '50') return 'Better (50)';
    return 'Best (65)';
  }

  function drillShapePhrase(s) {
    if (s.drill === 'round') return 'Round drills';
    if (s.drill === 'square') return 'Square drills';
    return null;
  }

  function sizeSummary(s) {
    if (!s || !s.sizeMode) return '—';
    if (s.sizeMode === 'range') return s.rangeSize ? rangeBandLabel(s.rangeSize) : '—';
    if (!s.exactSize) return '—';
    var opt = SIZE_BY_ID[s.exactSize];
    return opt ? opt.label : s.exactSize;
  }

  function formatConfiguredSpecLine(s) {
    var sizePart = s.sizeMode === 'range' ? 'Size Range ' + sizeSummary(s) : sizeSummary(s);
    var parts = [sizePart, clarityLabel(s.clarity)];
    var drill = drillShapePhrase(s);
    if (drill) parts.push(drill);
    return parts.join(' · ');
  }

  function reviewSpecRows(s) {
    if (!itemPricingInputsComplete(s)) {
      return [{ label: null, value: 'Required: size mode, canvas size or range, and clarity.' }];
    }
    var rows = [];
    if (s.sizeMode === 'range') {
      rows.push({ label: 'Size Range', value: sizeSummary(s) });
    } else {
      rows.push({ label: 'Size', value: sizeSummary(s) });
    }
    rows.push({ label: 'Clarity', value: clarityLabel(s.clarity) });
    if (!s.drill) {
      rows.push({ label: 'Drill shape', value: 'Select drill shape' });
    } else {
      rows.push({ label: 'Drill shape', value: drillShapePhrase(s) || '—' });
    }
    return rows;
  }

  function buildReviewSpecEl(s) {
    var wrap = document.createElement('div');
    wrap.className = 'review-line__spec';
    reviewSpecRows(s).forEach(function (row) {
      var line = document.createElement('div');
      line.className = 'review-spec-line';
      if (!row.label) {
        line.textContent = row.value;
        wrap.appendChild(line);
        return;
      }
      var lbl = document.createElement('span');
      lbl.className = 'review-spec-line__label';
      lbl.textContent = row.label + ': ';
      var val = document.createElement('span');
      val.className = 'review-spec-line__value';
      val.textContent = row.value;
      line.appendChild(lbl);
      line.appendChild(val);
      wrap.appendChild(line);
    });
    return wrap;
  }

  function formatSettingsLine(s) {
    if (!itemPricingInputsComplete(s)) {
      return 'Required: size mode, canvas size or range, and clarity.';
    }
    if (!s.drill) {
      return sizeSummary(s) + ' · ' + clarityLabel(s.clarity) + ' · Select drill shape to finish.';
    }
    return formatConfiguredSpecLine(s);
  }

  function bindEls() {
    els.root = document.getElementById('app');
    els.fileInput = document.getElementById('cs-file-input');
    els.uploadList = document.getElementById('cs-upload-list');
    els.fileCount = document.getElementById('cs-file-count');
    els.perFileList = document.getElementById('cs-per-file-list');
    els.bulkSizeMode = document.getElementById('bulk-size-mode');
    els.bulkExact = document.getElementById('bulk-exact-size');
    els.bulkRange = document.getElementById('bulk-range-size');
    els.bulkClarity = document.getElementById('bulk-clarity');
    els.bulkDrill = document.getElementById('bulk-drill');
    els.bulkExactWrap = document.querySelector('[data-bulk-exact-wrap]');
    els.bulkRangeWrap = document.querySelector('[data-bulk-range-wrap]');
    els.applyBulk = document.getElementById('cs-apply-bulk');
    refreshConfigureEls();
    els.prev = document.getElementById('cs-prev');
    els.next = document.getElementById('cs-next');
    els.submit = document.getElementById('cs-submit');
    els.reviewBody = document.getElementById('cs-review-body');
    els.subtotal = document.getElementById('cs-subtotal');
    els.name = document.getElementById('cs-name');
    els.mobile = document.getElementById('cs-mobile');
    els.email = document.getElementById('cs-email');
    els.live = document.getElementById('cs-live-status');
    els.toast = document.getElementById('cs-toast');
    els.panels = document.querySelectorAll('[data-step-panel]');
    els.stepperBtns = document.querySelectorAll('.steps__btn[data-go-step]');
    els.dropzone = document.querySelector('[data-dropzone]');
    els.lightbox = document.getElementById('cs-lightbox');
    els.lightboxImg = document.getElementById('cs-lightbox-img');
    els.lightboxCap = document.getElementById('cs-lightbox-cap');
    els.clarityWhyModal = document.getElementById('cs-clarity-why-modal');
    els.navActions = document.querySelector('.nav-actions');
  }

  function buildExclusiveButtons(container, optionList, selectedValue) {
    if (!container) return;
    container.innerHTML = '';
    optionList.forEach(function (spec) {
      var val = typeof spec === 'string' ? spec : (spec.value != null ? spec.value : spec.id);
      var label = typeof spec === 'string' ? spec : (spec.label || spec.id || String(val));
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'choice-btn';
      b.setAttribute('data-value', val);
      b.textContent = label;
      if (typeof spec === 'object' && spec && spec.title) {
        b.setAttribute('title', spec.title);
        b.setAttribute('aria-label', spec.title);
      }
      var on = selectedValue != null && selectedValue !== '' && String(val) === String(selectedValue);
      b.classList.toggle('is-selected', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      container.appendChild(b);
    });
  }

  function getGroupValue(container) {
    if (!container) return null;
    var sel = container.querySelector('.choice-btn.is-selected');
    return sel ? sel.getAttribute('data-value') : null;
  }

  function wireExclusiveChoiceGroup(container, onChange) {
    if (!container) return;
    container.addEventListener('click', function (e) {
      var btn = e.target.closest('.choice-btn');
      if (!btn || !container.contains(btn)) return;
      container.querySelectorAll('.choice-btn').forEach(function (b) {
        var on = b === btn;
        b.classList.toggle('is-selected', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      if (onChange) onChange(btn.getAttribute('data-value'));
    });
  }

  function getFileCardStickyTop() {
    if (!els.root) return 0;
    var v = getComputedStyle(els.root).getPropertyValue('--file-card-sticky-top').trim();
    var n = parseFloat(v);
    return isNaN(n) ? 0 : n;
  }

  function updateStickyChromeOffsets() {
    if (!els.root) return;
    var themeTop = 0;
    var mast = document.querySelector('.masthead');
    if (mast) themeTop = Math.ceil(mast.getBoundingClientRect().height);
    var app = document.getElementById('app');
    var headerSel = 'header.shopify-section-header, .shopify-section-group-header-group, sticky-header, .header-wrapper, #shopify-section-header, header.header';
    document.querySelectorAll(headerSel).forEach(function (el) {
      if (app && app.contains(el)) return;
      var style = getComputedStyle(el);
      if (style.position !== 'fixed' && style.position !== 'sticky') return;
      var r = el.getBoundingClientRect();
      if (r.height > 0 && r.top <= 1) themeTop = Math.max(themeTop, Math.ceil(r.bottom));
    });
    var steps = document.querySelector('.steps');
    var stepsH = steps ? Math.ceil(steps.offsetHeight) : 0;
    els.root.style.setProperty('--sticky-theme-top', themeTop + 'px');
    els.root.style.setProperty('--sticky-steps-h', stepsH + 'px');
    els.root.style.setProperty('--sticky-outer-summary-top', (themeTop + stepsH) + 'px');
  }

  function updateFileCardStickyOffset() {
    updateStickyChromeOffsets();
  }

  function getStickyOffset() {
    updateStickyChromeOffsets();
    var offset = getFileCardStickyTop();
    var app = document.getElementById('app');
    var headerSel = 'header.shopify-section-header, .shopify-section-group-header-group, sticky-header, .header-wrapper, #shopify-section-header, header.header';
    document.querySelectorAll(headerSel).forEach(function (el) {
      if (app && app.contains(el)) return;
      var style = getComputedStyle(el);
      if (style.position !== 'fixed' && style.position !== 'sticky') return;
      var r = el.getBoundingClientRect();
      if (r.height > 0 && r.top <= 1) offset = Math.max(offset, Math.ceil(r.bottom));
    });
    return offset;
  }

  function getScrollTargets() {
    var list = [];
    var seen = [];
    function add(el) {
      if (!el || seen.indexOf(el) !== -1) return;
      seen.push(el);
      list.push(el);
    }
    var node = document.getElementById('app');
    while (node) {
      if (node.scrollHeight > node.clientHeight + 1) {
        var style = getComputedStyle(node);
        if (/(auto|scroll|overlay)/.test(style.overflowY)) add(node);
      }
      node = node.parentElement;
    }
    add(document.scrollingElement);
    add(document.documentElement);
    add(document.body);
    document.querySelectorAll('main, #MainContent, .content-for-layout').forEach(add);
    return list;
  }

  function applyScrollDelta(deltaY) {
    if (!deltaY) return;
    var winBefore = window.scrollY || window.pageYOffset || 0;
    window.scrollTo(0, Math.max(0, winBefore + deltaY));
    if (window.scrollY !== winBefore) return;
    getScrollTargets().forEach(function (t) {
      if (!t || t === document.documentElement || t === document.body) return;
      var before = t.scrollTop;
      t.scrollTop += deltaY;
    });
  }

  function alignElementToStickyTop(targetEl, stickyTop) {
    if (!targetEl) return;
    var i;
    for (i = 0; i < 5; i++) {
      var rect = targetEl.getBoundingClientRect();
      var delta = rect.top - stickyTop;
      if (Math.abs(delta) < 2) break;
      applyScrollDelta(delta);
      var parent = targetEl.parentElement;
      while (parent) {
        var style = getComputedStyle(parent);
        if (/(auto|scroll|overlay)/.test(style.overflowY) && parent.scrollHeight > parent.clientHeight + 1) {
          rect = targetEl.getBoundingClientRect();
          var pr = parent.getBoundingClientRect();
          var localDelta = rect.top - pr.top - stickyTop;
          if (Math.abs(localDelta) > 2) parent.scrollTop += localDelta;
        }
        parent = parent.parentElement;
      }
    }
  }

  function scrollElementToStickyTop(targetEl) {
    if (!targetEl || isConfigureScrollSuppressed()) return;
    function run() {
      if (isConfigureScrollSuppressed()) return;
      alignElementToStickyTop(targetEl, getStickyOffset());
    }
    run();
    requestAnimationFrame(run);
  }

  function scrollToConfigureAnchor() {
    if (isConfigureScrollSuppressed()) return;
    var target = null;
    if (els.individualImagesPanel) {
      target = els.individualImagesPanel.querySelector(':scope > summary');
    }
    if (!target) target = document.querySelector('#panel-configure .panel__h');
    if (!target) target = document.getElementById('panel-configure');
    scrollElementToStickyTop(target);
  }

  function scheduleScrollOpenCard(det) {
    if (!det || !det.open || isConfigureScrollSuppressed()) return;
    var body = det.querySelector('.file-card__body');
    if (body) body.scrollTop = 0;
    var summary = det.querySelector(':scope > summary');
    if (!summary) return;
    scrollElementToStickyTop(summary);
    requestAnimationFrame(function () {
      if (body) body.scrollTop = 0;
      if (det.open && !isConfigureScrollSuppressed()) scrollElementToStickyTop(summary);
    });
  }

  function wireExclusiveDetailsGroup(nodeList, scrollOnOpen) {
    Array.prototype.forEach.call(nodeList, function (det) {
      det.addEventListener('toggle', function () {
        if (!det.open) return;
        Array.prototype.forEach.call(nodeList, function (other) {
          if (other !== det) other.open = false;
        });
        void det.offsetHeight;
        if (scrollOnOpen) scheduleScrollOpenCard(det);
      });
    });
  }

  function wireConfigurePanelAccordions() {
    var panel = document.getElementById('panel-configure');
    if (!panel) return;
    var tops = panel.querySelectorAll(':scope > details.card--nested');
    wireExclusiveDetailsGroup(tops, false);
    Array.prototype.forEach.call(tops, function (det) {
      det.addEventListener('toggle', function () {
        requestAnimationFrame(updateStickyChromeOffsets);
        if (det.open) {
          if (!isConfigureScrollSuppressed()) {
            var summary = det.querySelector(':scope > summary');
            if (summary) scrollElementToStickyTop(summary);
          }
          return;
        }
        if (det.hasAttribute('data-bulk-settings') && !det.classList.contains('bulk-settings--hidden')) {
          requestAnimationFrame(scrollToConfigureAnchor);
        }
      });
    });
  }

  function wirePerFileAccordions() {
    if (!els.perFileList) return;
    wireExclusiveDetailsGroup(els.perFileList.querySelectorAll('details.file-card'), true);
  }

  function initBulkChoiceGroups() {
    buildExclusiveButtons(els.bulkSizeMode, SIZE_MODE_OPTS, null);
    buildExclusiveButtons(els.bulkExact, sizesToChoices(exactSizesForBulkApply()), null);
    buildExclusiveButtons(els.bulkRange, RANGE_BANDS.map(function (b) {
      return { value: b.value, label: b.label };
    }), null);
    buildExclusiveButtons(els.bulkClarity, CLARITY_OPTS, null);
    buildExclusiveButtons(els.bulkDrill, DRILL_OPTS, null);
  }

  function recalcItem(it) {
    it.linePrice = calculateLinePricing(it.settings);
  }

  function recalcAll() {
    state.items.forEach(recalcItem);
  }

  function announce(msg) {
    if (els.live) els.live.textContent = msg;
  }

  function showToast(msg) {
    if (!els.toast) return;
    els.toast.textContent = msg;
    els.toast.hidden = false;
    clearTimeout(showToast._t);
    showToast._t = setTimeout(function () { els.toast.hidden = true; }, 3500);
  }

  function readBulkSettings() {
    return {
      sizeMode: getGroupValue(els.bulkSizeMode),
      exactSize: getGroupValue(els.bulkExact),
      rangeSize: getGroupValue(els.bulkRange),
      clarity: getGroupValue(els.bulkClarity),
      drill: getGroupValue(els.bulkDrill)
    };
  }

  function setFieldWrapHidden(el, hidden) {
    if (!el) return;
    el.hidden = hidden;
    el.classList.toggle('field--hidden', hidden);
  }

  function syncBulkUI() {
    var mode = getGroupValue(els.bulkSizeMode);
    if (!mode) {
      setFieldWrapHidden(els.bulkExactWrap, true);
      setFieldWrapHidden(els.bulkRangeWrap, true);
      return;
    }
    setFieldWrapHidden(els.bulkExactWrap, false);
    setFieldWrapHidden(els.bulkRangeWrap, false);
    var isRange = mode === 'range';
    setFieldWrapHidden(els.bulkExactWrap, isRange);
    setFieldWrapHidden(els.bulkRangeWrap, !isRange);
    if (isRange) setBulkRangeHint();
  }

  function applyBulkToAll() {
    var b = readBulkSettings();
    if (!itemSettingsComplete(b)) {
      showToast('Complete every bulk option (size mode, canvas size or range, clarity, and drill) before applying.');
      return;
    }
    if (b.sizeMode === 'exact' && b.exactSize) {
      var mismatch = state.items.some(function (it) {
        return !idSetFromSizes(exactSizeChoicesForItem(it))[b.exactSize];
      });
      if (mismatch) {
        showToast('That canvas size is not available for every image. Choose another size or set each image separately.');
        return;
      }
    }
    state.items.forEach(function (it) {
      it.settings.sizeMode = b.sizeMode;
      it.settings.exactSize = b.exactSize;
      it.settings.rangeSize = b.rangeSize;
      it.settings.clarity = b.clarity;
      it.settings.drill = b.drill;
      recalcItem(it);
    });
    renderPerFileCards();
    closeBulkSettingsPanel();
    updateConfigureProgress();
    showToast('Applied settings to all ' + state.items.length + ' image(s).');
  }

  function normalizeFileName(name) {
    return String(name || '').trim().toLowerCase();
  }

  function isImageFile(file) {
    if (!file) return false;
    if (file.type && file.type.indexOf('image/') === 0) return true;
    return /\.(jpe?g|png|gif|webp|heic|heif|bmp|avif|tiff?)$/i.test(file.name || '');
  }

  function addFiles(fileList) {
    if (!fileList || !fileList.length) return;
    var files = Array.prototype.slice.call(fileList, 0);
    var room = MAX_FILES - state.items.length;
    if (room <= 0) {
      showToast('Maximum ' + MAX_FILES + ' images.');
      return;
    }

    var existing = {};
    state.items.forEach(function (it) {
      existing[normalizeFileName(it.file.name)] = true;
    });
    var batchSeen = {};
    var accepted = [];
    var duplicates = [];
    var skipped = 0;

    files.forEach(function (file) {
      if (!isImageFile(file)) {
        skipped += 1;
        return;
      }
      var key = normalizeFileName(file.name);
      if (existing[key] || batchSeen[key]) {
        if (duplicates.indexOf(file.name) === -1) duplicates.push(file.name);
        return;
      }
      batchSeen[key] = true;
      accepted.push(file);
    });

    if (duplicates.length) {
      var dupMsg = duplicates.length === 1
        ? 'You already added "' + duplicates[0] + '". That duplicate was not added.'
        : 'You already added these photos: ' + duplicates.map(function (n) { return '"' + n + '"'; }).join(', ') + '. Duplicates were not added.';
      showToast(dupMsg);
    }

    if (!accepted.length) {
      if (skipped > 0) showToast('Please choose image files (JPEG, PNG, HEIC, etc.).');
      return;
    }

    if (accepted.length > room) {
      showToast('Only ' + room + ' more slot(s). Extra files ignored.');
      accepted = accepted.slice(0, room);
    }

    accepted.forEach(function (file) {
      var url = URL.createObjectURL(file);
      var item = {
        id: uid(),
        file: file,
        objectUrl: url,
        settings: Object.assign({}, emptySettings()),
        imageWidthPx: null,
        imageHeightPx: null,
        imageAspectRatio: null,
        imageMetaError: false
      };
      state.items.push(item);
      existing[normalizeFileName(file.name)] = true;
      recalcItem(item);
      scheduleImageAspectDetection(item, url);
    });
    renderUploadThumbs();
    renderPerFileCards();
    rebuildBulkExactButtons();
    updateFileCount();
    announce(state.items.length + ' image(s) in list');
  }

  function removeItem(id) {
    state.items = state.items.filter(function (it) {
      if (it.id === id) {
        URL.revokeObjectURL(it.objectUrl);
        return false;
      }
      return true;
    });
    renderUploadThumbs();
    renderPerFileCards();
    rebuildBulkExactButtons();
    updateFileCount();
  }

  function updateFileCount() {
    if (!els.fileCount) return;
    var n = state.items.length;
    els.fileCount.textContent = n === 0
      ? 'No files added yet.'
      : n + ' of ' + MAX_FILES + ' image(s) — ready to configure.';
  }

  function renderUploadThumbs() {
    if (!els.uploadList) return;
    els.uploadList.innerHTML = '';
    state.items.forEach(function (it) {
      var li = document.createElement('li');
      var img = document.createElement('img');
      img.src = it.objectUrl;
      img.alt = it.file.name;
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'thumb-remove';
      btn.setAttribute('aria-label', 'Remove ' + it.file.name);
      btn.textContent = '×';
      btn.addEventListener('click', function () { removeItem(it.id); });
      li.appendChild(img);
      li.appendChild(btn);
      els.uploadList.appendChild(li);
    });
  }

  function exactArHintText(it) {
    if (it.imageMetaError) return 'Could not read image dimensions. All sizes are shown.';
    if (it.imageAspectRatio == null || !isFinite(it.imageAspectRatio)) return 'Reading image dimensions…';
    var ratioTxt = imageAspectRatioDisplayLabel(it.imageWidthPx, it.imageHeightPx) || approximateAspectRatioLabel(it.imageAspectRatio);
    var key = classifyAspectKey(it.imageAspectRatio);
    if (key) return 'About ' + ratioTxt + ' → ' + key + ' sizes below.';
    return 'About ' + ratioTxt + '. No aspect bucket matched; showing all sizes.';
  }

  function renderPerFileCards() {
    if (!els.perFileList) refreshConfigureEls();
    if (!els.perFileList) return;
    els.perFileList.innerHTML = '';
    state.items.forEach(function (it) {
      var det = document.createElement('details');
      det.className = 'file-card';
      det.dataset.itemId = it.id;
      syncFileCardCompleteState(det, it.settings);
      var sum = document.createElement('summary');
      var row = document.createElement('div');
      row.className = 'file-card__row';

      var thBtn = document.createElement('button');
      thBtn.type = 'button';
      thBtn.className = 'file-card__thumb-btn';
      thBtn.setAttribute('aria-label', 'View full image: ' + it.file.name);
      var th = document.createElement('img');
      th.className = 'file-card__thumb';
      th.src = it.objectUrl;
      th.alt = '';
      thBtn.appendChild(th);
      thBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        openLightbox(it.objectUrl, it.file.name);
      });

      var tit = document.createElement('span');
      tit.className = 'file-card__name';
      tit.textContent = it.file.name;

      var pr = document.createElement('span');
      pr.className = 'file-card__price';
      recalcItem(it);
      pr.textContent = formatLinePriceDisplay(it.linePrice);

      row.appendChild(thBtn);
      row.appendChild(tit);
      row.appendChild(pr);

      var status = document.createElement('div');
      status.className = 'file-card__status';
      function syncStatus() {
        status.textContent = formatSettingsLine(it.settings);
      }
      syncStatus();

      sum.appendChild(row);
      sum.appendChild(status);

      var body = document.createElement('div');
      body.className = 'file-card__body';
      var idBase = 'm-' + it.id;

      function mkField(labelText, idSuf) {
        var w = document.createElement('div');
        w.className = 'field';
        var l = document.createElement('div');
        l.className = 'label';
        l.id = idBase + idSuf;
        l.textContent = labelText;
        w.appendChild(l);
        return { wrap: w, label: l };
      }

      var modeF = mkField('Size', '-mode-lbl');
      var modeGroup = document.createElement('div');
      modeGroup.className = 'choice-group choice-group--mode';
      modeGroup.setAttribute('role', 'group');
      modeGroup.setAttribute('aria-labelledby', idBase + '-mode-lbl');
      buildExclusiveButtons(modeGroup, SIZE_MODE_OPTS, it.settings.sizeMode || null);
      modeF.wrap.appendChild(modeGroup);

      var exactF = mkField('Canvas size', '-exact-lbl');
      var exactGroup = document.createElement('div');
      exactGroup.className = 'choice-group choice-group--wrap';
      exactGroup.setAttribute('role', 'group');
      exactGroup.setAttribute('aria-labelledby', idBase + '-exact-lbl');
      buildExclusiveButtons(exactGroup, sizesToChoices(exactSizeChoicesForItem(it)), it.settings.exactSize || null);
      var exactHint = document.createElement('p');
      exactHint.className = 'field-hint';
      exactHint.textContent = exactArHintText(it);
      exactF.wrap.appendChild(exactGroup);
      exactF.wrap.appendChild(exactHint);

      var rangeF = mkField('Size range', '-range-lbl');
      var rangeGroup = document.createElement('div');
      rangeGroup.className = 'choice-group';
      rangeGroup.setAttribute('role', 'group');
      rangeGroup.setAttribute('aria-labelledby', idBase + '-range-lbl');
      buildExclusiveButtons(rangeGroup, RANGE_BANDS.map(function (b) {
        return { value: b.value, label: b.label };
      }), it.settings.rangeSize || null);
      var rangeHintP = document.createElement('p');
      rangeHintP.className = 'field-hint';
      rangeHintP.textContent = rangeSelectionHint(it.settings.sizeMode === 'range' ? it.settings.rangeSize : null);
      rangeF.wrap.appendChild(rangeGroup);
      rangeF.wrap.appendChild(rangeHintP);

      var clarWrap = document.createElement('div');
      clarWrap.className = 'field';
      var clarRow = document.createElement('div');
      clarRow.className = 'label-row';
      var clarLbl = document.createElement('div');
      clarLbl.className = 'label';
      clarLbl.id = idBase + '-clarity-lbl';
      clarLbl.textContent = 'Clarity (colours)';
      var clarWhy = document.createElement('button');
      clarWhy.type = 'button';
      clarWhy.className = 'linkish';
      clarWhy.setAttribute('data-open-clarity-why', '');
      clarWhy.textContent = 'Why does colour count change the price?';
      clarRow.appendChild(clarLbl);
      clarRow.appendChild(clarWhy);
      var clarGroup = document.createElement('div');
      clarGroup.className = 'choice-group';
      clarGroup.setAttribute('role', 'group');
      clarGroup.setAttribute('aria-labelledby', idBase + '-clarity-lbl');
      buildExclusiveButtons(clarGroup, CLARITY_OPTS, it.settings.clarity || null);
      clarWrap.appendChild(clarRow);
      clarWrap.appendChild(clarGroup);

      var drillF = mkField('Drill shape', '-drill-lbl');
      var drillGroup = document.createElement('div');
      drillGroup.className = 'choice-group';
      drillGroup.setAttribute('role', 'group');
      drillGroup.setAttribute('aria-labelledby', idBase + '-drill-lbl');
      buildExclusiveButtons(drillGroup, DRILL_OPTS, it.settings.drill || null);
      drillF.wrap.appendChild(drillGroup);

      function refreshMode() {
        var mode = getGroupValue(modeGroup);
        if (!mode) {
          setFieldWrapHidden(exactF.wrap, true);
          setFieldWrapHidden(rangeF.wrap, true);
          return;
        }
        var isR = mode === 'range';
        setFieldWrapHidden(exactF.wrap, isR);
        setFieldWrapHidden(rangeF.wrap, !isR);
      }

      function pullFromDom() {
        it.settings.sizeMode = getGroupValue(modeGroup);
        it.settings.clarity = getGroupValue(clarGroup);
        it.settings.drill = getGroupValue(drillGroup);
        if (it.settings.sizeMode === 'exact') {
          it.settings.exactSize = getGroupValue(exactGroup);
          it.settings.rangeSize = null;
        } else if (it.settings.sizeMode === 'range') {
          it.settings.rangeSize = getGroupValue(rangeGroup);
          it.settings.exactSize = null;
        } else {
          it.settings.exactSize = null;
          it.settings.rangeSize = null;
        }
        recalcItem(it);
        pr.textContent = formatLinePriceDisplay(it.linePrice);
        syncStatus();
        syncFileCardCompleteState(det, it.settings);
        updateConfigureProgress();
        rangeHintP.textContent = rangeSelectionHint(it.settings.sizeMode === 'range' ? it.settings.rangeSize : null);
      }

      wireExclusiveChoiceGroup(modeGroup, function () { refreshMode(); pullFromDom(); });
      wireExclusiveChoiceGroup(exactGroup, pullFromDom);
      wireExclusiveChoiceGroup(rangeGroup, pullFromDom);
      wireExclusiveChoiceGroup(clarGroup, pullFromDom);
      wireExclusiveChoiceGroup(drillGroup, pullFromDom);

      body.appendChild(modeF.wrap);
      body.appendChild(exactF.wrap);
      body.appendChild(rangeF.wrap);
      body.appendChild(clarWrap);
      body.appendChild(drillF.wrap);
      refreshMode();
      det.appendChild(sum);
      det.appendChild(body);
      els.perFileList.appendChild(det);
    });
    wirePerFileAccordions();
    updateStickyChromeOffsets();
    updateConfigureProgress();
  }

  function openLightbox(src, caption) {
    closeClarityWhyModal();
    if (!els.lightbox || !els.lightboxImg) return;
    els.lightboxImg.src = src;
    els.lightboxImg.alt = caption || 'Uploaded image';
    if (els.lightboxCap) els.lightboxCap.textContent = caption || '';
    els.lightbox.classList.add('is-open');
    els.lightbox.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closeLightbox() {
    if (!els.lightbox || !els.lightboxImg) return;
    els.lightbox.classList.remove('is-open');
    els.lightbox.setAttribute('aria-hidden', 'true');
    els.lightboxImg.src = '';
    if (!els.clarityWhyModal || !els.clarityWhyModal.classList.contains('is-open')) {
      document.body.style.overflow = '';
    }
  }

  function openClarityWhyModal() {
    closeLightbox();
    if (!els.clarityWhyModal) return;
    els.clarityWhyModal.classList.add('is-open');
    els.clarityWhyModal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    var c = els.clarityWhyModal.querySelector('.overlay__close');
    if (c) c.focus();
  }

  function closeClarityWhyModal() {
    if (!els.clarityWhyModal) return;
    els.clarityWhyModal.classList.remove('is-open');
    els.clarityWhyModal.setAttribute('aria-hidden', 'true');
    if (!els.lightbox || !els.lightbox.classList.contains('is-open')) {
      document.body.style.overflow = '';
    }
  }

  function bindClarityWhyModal() {
    if (els.root) {
      els.root.addEventListener('click', function (e) {
        if (!e.target.closest('[data-open-clarity-why]')) return;
        e.preventDefault();
        openClarityWhyModal();
      });
    }
    if (els.clarityWhyModal) {
      els.clarityWhyModal.querySelectorAll('[data-close-clarity-why]').forEach(function (btn) {
        btn.addEventListener('click', closeClarityWhyModal);
      });
    }
  }

  function bindLightbox() {
    if (!els.lightbox) return;
    els.lightbox.querySelectorAll('[data-close-lightbox]').forEach(function (btn) {
      btn.addEventListener('click', closeLightbox);
    });
  }

  function bindOverlayEscape() {
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      if (els.clarityWhyModal && els.clarityWhyModal.classList.contains('is-open')) {
        closeClarityWhyModal();
        return;
      }
      if (els.lightbox && els.lightbox.classList.contains('is-open')) closeLightbox();
    });
  }

  function setBulkRangeHint() {
    var el = document.getElementById('bulk-range-hint');
    if (!el) return;
    var mode = getGroupValue(els.bulkSizeMode);
    el.textContent = rangeSelectionHint(mode === 'range' ? getGroupValue(els.bulkRange) : null);
  }

  function renderReview() {
    recalcAll();
    els.reviewBody.innerHTML = '';
    if (!state.items.length) {
      var empty = document.createElement('p');
      empty.className = 'hint';
      empty.textContent = 'No images yet. Open Upload to add files.';
      els.reviewBody.appendChild(empty);
    }
    state.items.forEach(function (it) {
      var row = document.createElement('div');
      row.className = 'review-line';
      var im = document.createElement('img');
      im.src = it.objectUrl;
      im.alt = '';
      var main = document.createElement('div');
      main.className = 'review-line__main';
      var head = document.createElement('div');
      head.className = 'review-line__head';
      var t = document.createElement('div');
      t.className = 'review-line__name';
      t.textContent = it.file.name;
      var price = document.createElement('div');
      price.className = 'review-line__price';
      price.textContent = formatLinePriceDisplay(it.linePrice);
      head.appendChild(t);
      head.appendChild(price);
      main.appendChild(head);
      main.appendChild(buildReviewSpecEl(it.settings));
      row.appendChild(im);
      row.appendChild(main);
      els.reviewBody.appendChild(row);
    });
    var kv = document.createElement('dl');
    kv.className = 'review-kv';
    [['Name', els.name.value.trim()], ['Mobile', els.mobile.value.trim()], ['Email', els.email.value.trim()]].forEach(function (pair) {
      var dt = document.createElement('dt');
      dt.textContent = pair[0];
      var dd = document.createElement('dd');
      dd.textContent = pair[1];
      kv.appendChild(dt);
      kv.appendChild(dd);
    });
    els.reviewBody.appendChild(kv);
    var subAgg = aggregateLineSubtotal(state.items);
    els.subtotal.textContent = !state.items.length ? '—' : formatSubtotalDisplay(subAgg);
  }

  function validateStep(step) {
    if (step === 0 && !state.items.length) {
      showToast('Add at least one image to continue.');
      return false;
    }
    if (step === 1) {
      if (!state.items.length) {
        showToast('Add at least one image first.');
        return false;
      }
      if (state.items.some(function (it) { return !itemSettingsComplete(it.settings); })) {
        showToast('Complete all required settings for every image (size, clarity, and drill shape).');
        return false;
      }
      return true;
    }
    if (step === 2) {
      if (!els.name.value.trim()) {
        showToast('Please enter your name.');
        els.name.focus();
        return false;
      }
      if (!els.mobile.value.trim()) {
        showToast('Please enter your mobile number.');
        els.mobile.focus();
        return false;
      }
      if (!els.email.value.trim() || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(els.email.value.trim())) {
        showToast('Please enter a valid email.');
        els.email.focus();
        return false;
      }
    }
    return true;
  }

  function setStep(s) {
    s = Math.max(0, Math.min(3, s));
    state.step = s;
    els.panels.forEach(function (panel) {
      var i = parseInt(panel.getAttribute('data-step-panel'), 10);
      var on = i === state.step;
      panel.classList.toggle('panel--hidden', !on);
      panel.hidden = !on;
    });
    els.stepperBtns.forEach(function (btn) {
      var i = parseInt(btn.getAttribute('data-go-step'), 10);
      var done = i < state.step;
      var active = i === state.step;
      btn.classList.toggle('is-active', active);
      btn.classList.toggle('is-done', done || active);
      btn.disabled = false;
      if (active) btn.setAttribute('aria-current', 'step');
      else btn.removeAttribute('aria-current');
    });
    els.prev.disabled = state.step === 0;
    if (els.navActions) els.navActions.classList.toggle('nav-actions--review', state.step === 3);
    if (state.step === 3) {
      els.next.classList.add('is-hidden');
      els.next.hidden = true;
      els.submit.classList.remove('is-hidden');
      els.submit.hidden = false;
      renderReview();
    } else {
      els.next.classList.remove('is-hidden');
      els.next.hidden = false;
      els.submit.classList.add('is-hidden');
      els.submit.hidden = true;
    }
    if (state.step === 1) {
      suppressConfigureScroll(450);
      refreshConfigureEls();
      ensureConfigureCardsRendered();
      updateConfigureProgress();
      if (state.items.length === 1) {
        requestAnimationFrame(openConfigureForSingleImage);
      }
    }
    updateStickyChromeOffsets();
    announce('Step ' + (state.step + 1) + ' of 4');
  }

  function buildSubmissionPayload() {
    recalcAll();
    var agg = aggregateLineSubtotal(state.items);
    var totals = { currency: 'AUD', kind: 'exact', amount: agg.min };
    if (agg.ok && agg.min !== agg.max) {
      totals = { currency: 'AUD', kind: 'range', min: agg.min, max: agg.max };
    } else if (!agg.ok) {
      totals = { currency: 'AUD', kind: 'unknown' };
    }
    var shopDomain = typeof window !== 'undefined' && window.CUSTOM_SHOP_DOMAIN
      ? String(window.CUSTOM_SHOP_DOMAIN)
      : null;
    return {
      version: 1,
      submittedAt: new Date().toISOString(),
      source: {
        channel: 'shopify',
        shopDomain: shopDomain,
        pageUrl: typeof window !== 'undefined' && window.location ? window.location.href : null,
        customerId: typeof window !== 'undefined' && window.CUSTOM_CUSTOMER_ID != null
          ? window.CUSTOM_CUSTOMER_ID
          : null,
        customerEmail: typeof window !== 'undefined' && window.CUSTOM_CUSTOMER_EMAIL
          ? String(window.CUSTOM_CUSTOMER_EMAIL)
          : null
      },
      contact: {
        name: els.name.value.trim(),
        mobile: els.mobile.value.trim(),
        email: els.email.value.trim()
      },
      lines: state.items.map(function (it, index) {
        var s = it.settings;
        var price = it.linePrice;
        var linePrice = price
          ? (price.kind === 'exact'
            ? { currency: 'AUD', kind: 'exact', amount: price.amount }
            : { currency: 'AUD', kind: 'range', min: price.min, max: price.max })
          : { currency: 'AUD', kind: 'unknown' };
        return {
          clientLineId: it.id,
          fileIndex: index,
          fileName: it.file.name,
          fileSizeBytes: it.file.size,
          fileMime: it.file.type || null,
          image: {
            widthPx: it.imageWidthPx,
            heightPx: it.imageHeightPx,
            aspectRatio: it.imageAspectRatio,
            aspectKey: classifyAspectKey(it.imageAspectRatio)
          },
          settings: {
            sizeMode: s.sizeMode,
            exactSizeId: s.sizeMode === 'exact' ? s.exactSize : null,
            rangeBand: s.sizeMode === 'range' ? s.rangeSize : null,
            clarity: s.clarity,
            drill: s.drill
          },
          display: {
            sizeLabel: sizeSummary(s),
            clarityLabel: clarityLabel(s.clarity),
            drillLabel: drillShapePhrase(s)
          },
          price: linePrice
        };
      }),
      totals: totals
    };
  }

  function buildSubmissionFormData() {
    var payload = buildSubmissionPayload();
    var fd = new FormData();
    fd.append('payload', JSON.stringify(payload));
    state.items.forEach(function (it, index) {
      fd.append('file_' + index, it.file, it.file.name);
    });
    return fd;
  }

  function submitCustomRequest() {
    if (state.submitting) return;
    var submitUrl = getSubmitApiUrl();
    if (!submitUrl) {
      renderReview();
      var lines = state.items.map(function (it) {
        return it.file.name + ' (' + formatLinePriceDisplay(it.linePrice) + ')';
      }).join('\n');
      window.alert('Demo only — set window.CUSTOM_SUBMIT_API to your endpoint.\n\nWould submit ' +
        state.items.length + ' line(s) to ' + els.email.value.trim() + '.\n\n' + lines);
      showToast('Demo: set CUSTOM_SUBMIT_API in the theme to go live.');
      return;
    }
    state.submitting = true;
    if (els.submit) els.submit.disabled = true;
    showToast('Sending your request…');
    var submitHeaders = {};
    if (typeof window !== 'undefined' && window.CUSTOM_SUBMIT_TOKEN) {
      submitHeaders['X-Submit-Token'] = String(window.CUSTOM_SUBMIT_TOKEN);
    }
    fetch(submitUrl, {
      method: 'POST',
      headers: submitHeaders,
      body: buildSubmissionFormData(),
      credentials: 'omit'
    })
      .then(function (res) {
        return res.json().catch(function () { return {}; }).then(function (body) {
          return { ok: res.ok, status: res.status, body: body };
        });
      })
      .then(function (result) {
        state.submitting = false;
        if (els.submit) els.submit.disabled = false;
        if (result.ok && result.body && result.body.success) {
          if (typeof window !== 'undefined' && window.CUSTOM_SUBMIT_DEBUG) {
            console.log('[custom-submit] response', result.body);
          }
          showToast(result.body.message || 'Request submitted. Thank you!');
          announce('Submitted ' + (result.body.referenceId || ''));
          return;
        }
        var msg = (result.body && result.body.message) ||
          'Submission failed (' + result.status + '). Please try again or contact us.';
        showToast(msg);
      })
      .catch(function () {
        state.submitting = false;
        if (els.submit) els.submit.disabled = false;
        showToast('Network error. Check your connection and try again.');
      });
  }

  function onSubmit() {
    if (!state.items.length) {
      showToast('Add at least one image before submitting.');
      setStep(0);
      return;
    }
    if (!validateStep(1)) {
      setStep(1);
      return;
    }
    if (!validateStep(2)) {
      setStep(2);
      return;
    }
    renderReview();
    submitCustomRequest();
  }

  function bindFileUploadHandlers() {
    if (!els.fileInput) return;
    els.fileInput.addEventListener('change', function () {
      if (els.fileInput.files && els.fileInput.files.length) addFiles(els.fileInput.files);
      els.fileInput.value = '';
    });
    if (!els.dropzone) return;
    ['dragenter', 'dragover'].forEach(function (ev) {
      els.dropzone.addEventListener(ev, function (e) {
        e.preventDefault();
        e.stopPropagation();
        els.dropzone.classList.add('is-dragover');
      });
    });
    ['dragleave', 'drop'].forEach(function (ev) {
      els.dropzone.addEventListener(ev, function (e) {
        e.preventDefault();
        e.stopPropagation();
        els.dropzone.classList.remove('is-dragover');
      });
    });
    els.dropzone.addEventListener('drop', function (e) {
      var dt = e.dataTransfer;
      if (dt && dt.files && dt.files.length) addFiles(dt.files);
    });
  }

  function finishInit() {
    bindFileUploadHandlers();
    updateFileCardStickyOffset();
    window.addEventListener('resize', updateFileCardStickyOffset);
    setBulkRangeHint();
    bindLightbox();
    bindClarityWhyModal();
    bindOverlayEscape();
    initBulkChoiceGroups();
    wireConfigurePanelAccordions();
    updateConfigureProgress();
    wireExclusiveChoiceGroup(els.bulkSizeMode, syncBulkUI);
    wireExclusiveChoiceGroup(els.bulkExact, null);
    wireExclusiveChoiceGroup(els.bulkRange, setBulkRangeHint);
    wireExclusiveChoiceGroup(els.bulkClarity, null);
    wireExclusiveChoiceGroup(els.bulkDrill, null);
    syncBulkUI();
    if (els.applyBulk) els.applyBulk.addEventListener('click', applyBulkToAll);
    if (els.prev) els.prev.addEventListener('click', function () { setStep(state.step - 1); });
    if (els.next) {
      els.next.addEventListener('click', function () {
        if (validateStep(state.step)) setStep(state.step + 1);
      });
    }
    if (els.submit) els.submit.addEventListener('click', onSubmit);
    if (els.stepperBtns) {
      els.stepperBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          setStep(parseInt(btn.getAttribute('data-go-step'), 10));
        });
      });
    }
    setStep(0);
  }

  function init() {
    bindEls();
    initSizeCatalogue();
    finishInit();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
